import { FilterFunction, Row, ValueSelectorFunction } from "@cadmakers/data-grid-v2";
import { getSelectedValue } from "./GetSelectedValue";

const getRowValueByColumnId = (
  row: Row,
  columnId: string,
  valueSelector?: ValueSelectorFunction
) => {
  return getSelectedValue(row.values[columnId], valueSelector);
};

export const AssignedUsersFilter: FilterFunction<{ tags: string[]; operator?: "and" | "or" }> = (
  rows,
  id,
  filterValue,
  valueSelector
) => {
  const tags = filterValue?.tags ?? [];

  if (!tags) {
    return rows.map((_, i) => i);
  }

  const indicies: number[] = [];

  for (let i = 0; i < rows.length; i++) {
    const row = rows[i];
    const value = getRowValueByColumnId(row, id, valueSelector);

    if (Array.isArray(value)) {
      const names = value.map(x => x.name);

      const predicate = (tag: string) => names.includes(tag);

      const condition = tags.some(predicate);

      if (condition) {
        indicies.push(i);
      }
    } else if (tags.includes(value.name)) {
      indicies.push(i);
    }
  }

  return indicies;
};
